import * as Sentry from '@sentry/gatsby'

const CHUNK_ERROR_RE = /Loading chunk [\w-]+ failed|Loading CSS chunk|ChunkLoadError|error loading dynamically imported module|Importing a module script failed/i

// Si el chunk ya no existe, CloudFront responde index.html con 200 y el
// navegador lo ejecuta como JS: falla en el "<" de <!DOCTYPE html> con este
// mensaje (V8/JSC y Firefox) en lugar de un ChunkLoadError.
const HTML_AS_SCRIPT_RE = /^(Unexpected token '?<'?|expected expression, got '<')$/

const RELOAD_KEY = 'oky:chunkReloadAt'
const RELOAD_WINDOW_MS = 10000

export const isChunkError = error => {
  if (!error) {
    return false
  }

  if (typeof error === 'string') {
    return CHUNK_ERROR_RE.test(error)
  }

  if (error.name === 'ChunkLoadError') {
    return true
  }

  return CHUNK_ERROR_RE.test(error.message || '')
}

// Solo cuenta si el script que falló es uno de nuestros .js: un JSON.parse
// sobre HTML da otro mensaje, y un script de terceros no se arregla recargando.
export const isHtmlServedAsScript = (error, filename) => {
  if (error?.name !== 'SyntaxError' || !HTML_AS_SCRIPT_RE.test(error.message)) {
    return false
  }

  try {
    const url = new URL(filename, window.location.href)
    return url.origin === window.location.origin && url.pathname.endsWith('.js')
  } catch {
    return false
  }
}

const canReloadNow = () => {
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_KEY)) || 0
    if (Date.now() - last < RELOAD_WINDOW_MS) {
      return false
    }
    window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
    return true
  } catch {
    return true
  }
}

export const reloadOnceForChunkError = error => {
  if (typeof window === 'undefined') {
    return false
  }

  const recovered = canReloadNow()

  Sentry.captureException(
    error instanceof Error ? error : new Error(String(error)),
    { tags: { chunkLoadError: true, recovered } },
  )

  if (recovered) {
    window.location.reload()
  }

  return recovered
}
